import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { moderationListSearchSchema } from '@/entities/moderation';
import {
  createModerationParamsChange,
  moderationLoaderDeps,
  moderationRouteLoader,
  PromotionsModerationPage,
  requireAuthBeforeLoad,
} from '@/pages/moderation';

/** Promotions moderation queue — URL is the single source of truth for status/search/date/page. */
export const Route = createFileRoute('/moderation/promotions')({
  staticData: { permission: 'moderation.promotions.view' },
  beforeLoad: requireAuthBeforeLoad,
  validateSearch: moderationListSearchSchema,
  loaderDeps: moderationLoaderDeps,
  loader: moderationRouteLoader('promotions'),
  component: PromotionsModerationRoute,
});

function PromotionsModerationRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onParamsChange = createModerationParamsChange(search, (options) => {
    void navigate(options);
  });

  return <PromotionsModerationPage params={search} onParamsChange={onParamsChange} />;
}
